import { render } from "./AccountSubcontainer5.vue?vue&type=template&id=9251ad62&scoped=true"
import script from "./AccountSubcontainer5.vue?vue&type=script&lang=js"
export * from "./AccountSubcontainer5.vue?vue&type=script&lang=js"

import "./AccountSubcontainer5.vue?vue&type=style&index=0&id=9251ad62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9251ad62"

export default script